export default __webpack_public_path__ + "static/media/Tooltip-disabled.f419a021.svg";